import React from "react";
import { useTranslation } from "react-i18next";
import Arabia from "../assets/images/Insurance-logo/arabia.png";
import Madina from "../assets/images/Insurance-logo/madina_takaful.png";
import Oui from "../assets/images/Insurance-logo/oui.png";
import TakafulOman from "../assets/images/Insurance-logo/takaful_oman.png";
import Oqic from "../assets/images/Insurance-logo/oqic.png";
import Damana from "../assets/images/Insurance-logo/damana.png";
import Dhofar from "../assets/images/Insurance-logo/dhofar.png";
import Gig from "../assets/images/Insurance-logo/gig.png";
import Liva from "../assets/images/Insurance-logo/liva.png";
import Mic from "../assets/images/Insurance-logo/mic.png";
import Orient from "../assets/images/Insurance-logo/orient.png";
import Sukoon from "../assets/images/Insurance-logo/sukoon.png";
import India from "../assets/images/Insurance-logo/india_insurance.png";

const Partners = () => {
  const { t } = useTranslation();

  return (
    <section className="partners">
      <div className="container">
        <div className="services-title">
          {/* <h5 className="sub-title">Partners</h5> */}
          <h3 className="title">{t("ourPartners")}</h3>
        </div>
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-6 col-6">
            <div className="partners-box">
              <div className="partners-img">
                <img
                  src={Arabia}
                  alt="Partner_logo"
                  className="img-fluid"
                />
              </div>
              <div className="partners-text">
                <p>Arabia Falcon Insurance</p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6 col-6">
            <div className="partners-box">
              <div className="partners-img">
                <img src={Madina} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Al Madina Takaful</p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6 col-6">
            <div className="partners-box">
              <div className="partners-img">
                <img src={Oui} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Oman United Insurance</p>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6 col-6">
            <div className="partners-box">
              <div className="partners-img">
                <img src={TakafulOman} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Takaful Oman Insurance</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6 qatar">
            <div className="partners-box">
              <div className="partners-img">
                <img src={Oqic} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Oman Qatar Insurance </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6 qatar">
            <div className="partners-box">
              <div className="partners-img">
                <img src={Damana} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Damana Insurance</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6 qatar">
            <div className="partners-box">
              <div className="partners-img">
                <img src={Dhofar} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Dhofar Insurance</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6 qatar">
            <div className="partners-box">
              <div className="partners-img">
                <img src={Gig} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Gig Insurance</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6 qatar">
            <div className="partners-box">
              <div className="partners-img">
                <img src={Liva} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Liva Insurance</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6 qatar">
            <div className="partners-box">
              <div className="partners-img">
                <img src={Mic} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Muscat Insurance</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6 qatar">
            <div className="partners-box">
              <div className="partners-img">
                <img src={Orient} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Orient Insurance</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6 qatar">
            <div className="partners-box">
              <div className="partners-img">
                <img src={Sukoon} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>Sukoon Insurance</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6 qatar">
            <div className="partners-box">
              <div className="partners-img">
                <img src={India} alt="icon" className="img-fluid" />
              </div>
              <div className="partners-text">
                <p>India Insurance</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default Partners;
